export const REVIEW_MODAL_TYPE = {
  ROOM: 'room',
  USER: 'user',
};
